import { render, staticRenderFns } from "./TRadioGroup.vue?vue&type=template&id=09b58fd6&"
import script from "./TRadioGroup.vue?vue&type=script&lang=js&"
export * from "./TRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VFlex,VRadioGroup})
